import React from 'react';
import './styles.scss';
import { HighlightKeyStatsProps, StatsItem } from './models';

export class HighlightKeyStats extends React.Component<HighlightKeyStatsProps> {
  private componentRef = React.createRef<HTMLDivElement>();

  public componentDidMount(): void {
    this.initializeScrollAnimation();
    if (globalThis.window !== undefined) {
      globalThis.window?.addEventListener('scroll', this.handleScroll, true);
    }
  }

  public initializeScrollAnimation = () => {
    const element = this.componentRef.current;
    if (element && this.isElementInViewport(element)) {
      element.classList.add('play');
    }
  };

  public handleScroll = () => {
    const element = this.componentRef.current;
    if (element && !element.classList.contains('play')) {
      const elementRect = element.getBoundingClientRect();
      const elementHeight = element.offsetHeight;
      const scrollTop = globalThis.window?.pageYOffset || document.documentElement.scrollTop;
      const elementTop = elementRect.top + scrollTop;
      
      if (scrollTop >= elementTop - elementHeight * 0.8) {
        element.classList.add('play');
      }
    }
  };

  private isElementInViewport = (element: HTMLElement): boolean => {
    const rect = element.getBoundingClientRect();
    return rect.top <= 80;
  };

  public componentWillUnmount() {
    if (globalThis.window !== undefined) {
      globalThis.window?.removeEventListener('scroll', this.handleScroll, true);
    }
  }

  render(): React.ReactNode {
    const highlightKeyStatsData = this.props.data;
    if (!highlightKeyStatsData) {
      return null;
    }

    const {
      variation,
      backgroundColor,
      eyebrow,
      statsItems: statsItemsObj
    } = highlightKeyStatsData;

    // Convert statsItems object to array
  const statsItems: StatsItem[] = Object.values(statsItemsObj || {});

    const id = 'highlight-key-stats';

    return (
      <div 
        ref={this.componentRef}
        className="ge-highlight-keystats padding-top-96 padding-bottom-96"
        id={id}
        data-variation={variation}
        data-bgcolor={backgroundColor}
      >
        <div className="cmp-bg-color fullwidth"></div>
        <div className="ge-highlight-keystats-wrap">
          {eyebrow && (
            <div 
              className="text-eyebrow"
              dangerouslySetInnerHTML={{ __html: eyebrow }}
            />
          )}
          <div 
            className="keystats-wrapper"
            data-keystats-size={statsItems.length}
          >
            {statsItems.map((item, index) => (
              <div key={`keystat-${index}-${item.stats}`} className="keystats-card">
                <div 
                  className="keystat-value"
                  dangerouslySetInnerHTML={{ __html: item.stats || '' }}
                />
                {item.bodyCopyText && (
                  <div 
                    className="text-paragraph-s"
                    dangerouslySetInnerHTML={{ __html: item.bodyCopyText }}
                  />
                )}
                <div className="ketstat-line"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
